var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.05C0 12.155 0.845 13 1.95 13H11.05C12.155 13 13 12.155 13 11.05V5.85H0V11.05ZM11.05 1.3H9.75V0.65C9.75 0.26 9.49 0 9.1 0C8.71 0 8.45 0.26 8.45 0.65V1.3H4.55V0.65C4.55 0.26 4.29 0 3.9 0C3.51 0 3.25 0.26 3.25 0.65V1.3H1.95C0.845 1.3 0 2.145 0 3.25V4.55H13V3.25C13 2.145 12.155 1.3 11.05 1.3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon15);
export default __webpack_public_path__ + "static/media/icon-15.97c67f81535120673049bd82c4297661.svg";
export { ForwardRef as ReactComponent };